import { render, staticRenderFns } from "./GIdentitySigninButton.vue?vue&type=template&id=20b0653a&scoped=true&"
import script from "./GIdentitySigninButton.vue?vue&type=script&lang=js&"
export * from "./GIdentitySigninButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b0653a",
  null
  
)

export default component.exports